<script setup lang="ts">
import AppHeader from '@/components/AppHeader.vue'
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <AppHeader />
    <main class="flex-1">
      <slot />
    </main>
    <footer class="bg-gray-100 py-4 text-center text-sm text-gray-600">
      <p>Built with Edge Vue</p>
    </footer>
  </div>
</template>
